export const useServerSettings = () => {
  const { apiUrl } = useRuntimeConfig().public;

  function setApiUrl(url: string) {
    localStorage.setItem('apiUrl', url);
  }

  function getApiUrl() {
    const storedApiUrl = localStorage.getItem('apiUrl');
    return storedApiUrl || apiUrl;
  }

  return { getApiUrl, setApiUrl };
};
